module.exports = __webpack_public_path__ + "static/img/ex.f8afd9cf.png";